import { Announcement, EAnnouncementAppType } from '@insolution/graphql-data-access';

// Announcements that run today and target the given app. The seen ids decide which of these are
// shown as a banner and which can be brought back, so an id of a deleted or expired announcement
// lingering in local storage never resurfaces anything.
export function getActiveAnnouncements(announcements: Announcement[], appType: EAnnouncementAppType): Announcement[] {
  const today = new Date().toISOString().slice(0, 10);

  return announcements.filter(
    (announcement) => isForAppType(announcement, appType) && isWithinDateWindow(announcement, today)
  );
}

function isForAppType(announcement: Announcement, appType: EAnnouncementAppType): boolean {
  return announcement.appType === EAnnouncementAppType.Both || announcement.appType === appType;
}

function isWithinDateWindow(announcement: Announcement, today: string): boolean {
  return announcement.start_date <= today && today <= announcement.end_date;
}
